import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as me from '../../../me'
import * as routeBound from '../../../route-bound'
import * as rules from '../rules'

import { Api } from './api.service'
import * as effects from './effects'
import * as excel from './excel'
import type { TypeParams } from './types'

// TODO: maybe this should be somewhere that is shared so that it can be the
// default for lots of different ECs.
const DEFAULT_QUANTITY = 100

@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  private readonly _rulesEc = ngCore.inject(rules.Collection)

  constructor() {
    super({
      api: ngCore.inject(Api),
      context$: ngCore.inject(routeBound.scenario.Context.TOKEN),
      identify: record => record.id,
      name: ec.Name.Predefined.RateGlRecord,
      plugins: {
        additionalFactories: [
          new excel.Factory(),
          new ds.table.ec.Factory<TypeParams>({
            rowConfig: ({ entity }) => ({
              onClick: () => {
                this.plugins.currentEntityPlugin.storage.actions.putInIdLookup
                  .from('Table.Row.Clicked')
                  .dispatch({ value: entity.id })
              },
            }),
          }),
        ],
        currentList: {
          quantity: {
            get: quantity => quantity ?? DEFAULT_QUANTITY,
          },
        },
      },
    })
    this.feature.registerEffects(
      effects.setApplicableRulesForCurrentRecord(this, this._rulesEc),
    )
  }
}
